import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Spin ,Image, Typography, Table, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function Uom() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [uoms, setUoms] = useState([]);
    const [filteredUoms, setFilteredUoms] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editUom, setEditUom] = useState(null);
    const [selectedUom, setSelectedUom] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchUoms();
    }, []);

    const fetchUoms = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/uom/all`, { headers });
            setUoms(response.data);
            setFilteredUoms(response.data);
        } catch (error) {
            AlertError("Failed to fetch Uoms");
        } finally {
            setLoading(false);
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (uom) => {
     
        setEditUom(uom);
        form.setFieldsValue({
           // ProductTypeCode: ProductType.ProductTypeCode,
            uomName: uom.uomName,
            uomActiveStatus: uom.uomActiveStatus === true,
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateUom = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            const requestData = {
                uomName: values.uomName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/uom/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Uom successfully added!");
                handleCancel();
                fetchUoms();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add Uom!");
        }finally {
            setLoading(false);
        }
    };
    const handleUpdateUom = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            const requestData = {
                uomId: editUom.uomId,
                uomName: values.uomName,
                uomActiveStatus: values.uomActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/master/uom/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("UOM successfully updated!");
                handleCancel();
                fetchUoms();
            }
        } catch (error) {
            console.log(error);
            AlertError(error.response?.data?.message || "Failed to update Uom!");
        }finally {
            setLoading(false);
        }
    };

    const handleDeleteUom = async (id) => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/master/uom/delete/${id}`, { headers });
            AlertSuccess("UOM deleted successfully!");
            fetchUoms();
        } catch (error) {
            AlertError("Failed to delete Uom!");
        }finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        setLoading(true);
        let filtered = uoms;

        if (selectedUom) {
            filtered = filtered.filter(uom => uom.uomId === selectedUom);
        }

        if (keyword) {
            filtered = filtered.filter(uom => uom.uomId.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredUoms(filtered);
       
     setLoading(false);
        
    };

   
    const handleReset = () => {
        setLoading(true);
        setKeyword('');
        setSelectedUom(null);
        setFilteredUoms(uoms);
        setLoading(false);
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this Uom?"
                        onConfirm={() => handleDeleteUom(record.uomId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'UOM Name',
            dataIndex: 'uomName',
            key: 'uomName',
            sorter: (a, b) => a.uomName.localeCompare(b.uomName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'uomActiveStatus',
            key: 'uomActiveStatus',
            render: (uomActiveStatus) => (
                <Tag color={uomActiveStatus === true ? "green" : "red"}>
                    {uomActiveStatus === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Spin spinning={loading} tip="Processing...">
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item>UOMs</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'10px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        
                        <Typography.Title level={5}>List of UOM</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredUoms}
                            rowKey="uomId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New UOM"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateUom}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[
                            { required: true, message: "ProductType code is required" },
                            { len: 4, message: "ProductType code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}

                    <Form.Item
                        label="UOM Name"
                        name="uomName"
                        rules={[{ required: true, message: "UOM name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit UOM"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateUom}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[{ required: true, message: "ProductType code is required" }, { len: 4, message: "ProductType code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}
                    <Form.Item
                        label="UOM Name"
                        name="uomName"
                        rules={[{ required: true, message: "UOM name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Active Status"
                        name="uomActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editUom?.selectedUom?.uomActiveStatus === true} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
        </Spin>
    );
}

export default Uom;